export enum RoleCode {
  Manager = 'ROLE_MANAGER',
  Consultant = 'ROLE_CONSULTANT',
  Administrator = 'ROLE_ADMIN',
  Financial = 'ROLE_FINANCIAL',
  SuperAdmin = 'ROLE_SUPER_ADMIN',
}

export const RoleOptions: { slug: string; label: string }[] = [
  { slug: 'manager', label: 'Manager' },
  { slug: 'consultant', label: 'Consultant' },
  { slug: 'administrator', label: 'Administrator' },
  { slug: 'financial', label: 'Financial' },
  { slug: 'super_admin', label: 'Super Admin' },
];

export const Roles = RoleOptions.map(r => r.slug);

export const RoleLabelMap: Record<string, string> = Object.fromEntries(
  RoleOptions.map(r => [r.slug, r.label])
);

export const RestrictedRoles = ['financial', 'super_admin'];
